import { render } from "./AdminStudentBooking.vue?vue&type=template&id=218ace97&scoped=true"
import script from "./AdminStudentBooking.vue?vue&type=script&lang=js"
export * from "./AdminStudentBooking.vue?vue&type=script&lang=js"

import "./AdminStudentBooking.vue?vue&type=style&index=0&id=218ace97&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-218ace97"]])

export default __exports__